module.exports = __webpack_public_path__ + "static/img/home_02.1e2652f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/home_02.png
// module id = fUeP
// module chunks = 34